import { render } from "./uploadFile.vue?vue&type=template&id=fdd49fe0&scoped=true&ts=true"
import script from "./uploadFile.ts?vue&type=script&lang=ts&external"
export * from "./uploadFile.ts?vue&type=script&lang=ts&external"

import "./uploadFile.scss?vue&type=style&index=0&id=fdd49fe0&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd49fe0"]])

export default __exports__